import { useState } from 'react'
import { useApiClient } from '@/hooks'
import { downloadApiResponse } from '@/utils'
import { UseQuotationsParams } from './useQuotations'

export const useQuotationsExport = () => {
  const client = useApiClient()

  const [loading, setLoading] = useState(false)

  const doExport = async ({ ...params }: UseQuotationsParams) => {
    const queryParams = new URLSearchParams()

    if (params.client) queryParams.append('client', params.client)
    if (params.status) queryParams.append('status', params.status)
    if (params.project_leader)
      queryParams.append('project_leader', params.project_leader)
    if (params.search) queryParams.append('search', params.search)

    setLoading(true)
    try {
      const response = await client.get<Blob>(
        `/quotations/export/?${queryParams.toString()}`,
        { responseType: 'blob' }
      )

      downloadApiResponse(response)
    } finally {
      setLoading(false)
    }
  }

  return { doExport, loading }
}
